import React from 'react'
import { useRef, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";


const PostComments = ({
    highlightedCommentId,
    showCommentPanel,
    setShowCommentPanel,
    commentListRef,
    commentsLoading,
    commentsList,
    formatDate,
    editingCommentId,
    editedCommentText,
    setEditedCommentText,
    setEditingCommentId,
    handleSaveComment,
    id_user,
    post,
    confirmDeleteComment,
    handleTogglePin,
    handleEditComment,
    replyingTo,
    replyingUser,
    setReplyingTo,
    setReplyingUser,
    replyText,
    setReplyText,
    handleReply,
    expandedReplies,
    setExpandedReplies,
    handleLikeComment,
    renderReplyItem,
    newComment,
    setNewComment,
    handleAddComment,
    FaHeart,
    scrollToLastComment = false,
    isViewer = false,
}) => {

    const navigate = useNavigate();


    const lastCommentRef = useRef(null);
    const commentRefs = useRef({});

    const { t } = useTranslation();

    useEffect(() => {

        if (
            !highlightedCommentId ||
            !commentsList?.length
        ) return;

        const timer = setTimeout(() => {

            const target =
                commentRefs.current[
                highlightedCommentId
                ];

            if (target) {
                const container = commentListRef.current;

                if (container && target) {
                    const containerTop = container.getBoundingClientRect().top;
                    const targetTop = target.getBoundingClientRect().top;
                    const scrollOffset = targetTop - containerTop;
                    container.scrollTo({
                        top:
                            container.scrollTop +
                            scrollOffset -
                            120,
                        behavior: "smooth"
                    });
                }

            }

        }, 800);

        return () => clearTimeout(timer);

    }, [
        highlightedCommentId,
        commentsList
    ]);


    useEffect(() => {

        if (
            !scrollToLastComment ||
            !commentsList?.length
        ) return;

        const timer = setTimeout(() => {

            if (lastCommentRef.current) {

                lastCommentRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });

            }

        }, 250);

        return () => clearTimeout(timer);

    }, [commentsList, scrollToLastComment]);


    const safeComments = Array.isArray(commentsList)
        ? commentsList
        : [];


    return (
        <>
            {showCommentPanel && (
                <div
                    className={
                        isViewer
                            ? "viewer-comments-wrapper"
                            : "comment-overlay"
                    }

                    onClick={
                        isViewer
                            ? undefined
                            : () => setShowCommentPanel(false)
                    }
                >

                    <div
                        className={
                            isViewer
                                ? "viewer-comment-panel"
                                : "comment-panel"
                        }
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div className="comment-header">

                            <span className="comments-title">
                                {t("comments.title")}
                            </span>

                            <button
                                className="close-comments-btn"
                                onClick={() => setShowCommentPanel(false)}
                            >
                                <IoClose />
                            </button>

                        </div>

                        {/* <div className="comment-header">
                            <span className="comments-title"> {t("comments.title")} </span>
                        </div> */}

                        <div className="comment-list" ref={commentListRef}>
                            {commentsLoading ? (

                                Array.from({ length: 3 }).map((_, i) => (
                                    <div key={i} className="comment-skeleton">
                                        <div className="skeleton avatar"></div>
                                        <div className="skeleton text"></div>
                                    </div>
                                ))

                            ) : safeComments.length === 0 ? (

                                <p className="no-comments">
                                    {t("comments.noComments")}
                                </p>

                            ) : (

                                safeComments.map((c, index) => (
                                    <div
                                        key={c.id_comment}
                                        className={`comment-item ${Number(highlightedCommentId) === Number(c.id_comment) ? "highlighted-comment" : ""}`}
                                        ref={(el) =>
                                            commentRefs.current[
                                            c.id_comment
                                            ] = el
                                        }
                                    >

                                        <div className="comment-left">

                                            <div className="comment-top">
                                                <b className="comment-username-link" onClick={() => navigate(`/user/${c.username}`)}>{c.username}</b>

                                                {c.is_pinned === 1 && (
                                                    <span className="pin-badge"> 📌 {t("comments.pinned")} </span>
                                                )}

                                                <span className="comment-date">
                                                    {formatDate(c.created_at)}
                                                </span>
                                            </div>


                                            {editingCommentId === c.id_comment ? (

                                                <div className="edit-comment-box">
                                                    <input
                                                        type="text"
                                                        value={editedCommentText}
                                                        onChange={(e) => setEditedCommentText(e.target.value)}
                                                    />

                                                    <div className="edit-actions">
                                                        <button onClick={() => setEditingCommentId(null)}>
                                                            {t("comments.cancel")}
                                                        </button>

                                                        <button onClick={() => handleSaveComment(c.id_comment)}>
                                                            {t("comments.save")}
                                                        </button>
                                                    </div>
                                                </div>

                                            ) : (

                                                <>
                                                    <p>{c.comment}</p>

                                                    <div className="comment-bottom-actions">

                                                        {(parseInt(c.id_user) === parseInt(id_user) ||
                                                            parseInt(post.id_user) === parseInt(id_user)) && (
                                                                <button
                                                                    className="delete-comment"
                                                                    onClick={() => confirmDeleteComment(c.id_comment)}
                                                                >
                                                                    {t("comments.delete")}
                                                                </button>
                                                            )}

                                                        {parseInt(post.id_user) === parseInt(id_user) && (
                                                            <button
                                                                className="pin-comment"
                                                                onClick={() => handleTogglePin(c.id_comment)}
                                                            >
                                                                {
                                                                    c.is_pinned
                                                                        ? t("comments.unpin")
                                                                        : t("comments.pin")
                                                                }
                                                            </button>
                                                        )}

                                                        {parseInt(c.id_user) === parseInt(id_user) && (
                                                            <button
                                                                className="pin-comment"
                                                                onClick={() => handleEditComment(c)}
                                                            >
                                                                {t("comments.edit")}
                                                            </button>
                                                        )}

                                                        <button
                                                            className="pin-comment"
                                                            onClick={() => {
                                                                setReplyingTo(c.id_comment);
                                                                setReplyingUser(c.username);
                                                            }}
                                                        >
                                                            {t("comments.reply")}
                                                        </button>

                                                    </div>

                                                    {replyingTo === c.id_comment && (
                                                        <div className="reply-box">
                                                            <input
                                                                type="text"
                                                                placeholder={
                                                                    t(
                                                                        "comments.replyTo",
                                                                        {
                                                                            username:
                                                                                replyingUser ||
                                                                                c.username
                                                                        }
                                                                    )
                                                                }
                                                                value={replyText}
                                                                onChange={(e) => setReplyText(e.target.value)}
                                                            />

                                                            <div className="reply-actions">
                                                                <button onClick={() => setReplyingTo(null)}>
                                                                    {t("comments.cancel")}
                                                                </button>

                                                                <button onClick={() => handleReply(c.id_comment)}>
                                                                    {t("comments.reply")}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {c.replies && c.replies.length > 0 && (
                                                        <div className="replies-container">

                                                            {/*  afficher 1 ou tous */}
                                                            {(expandedReplies[c.id_comment]
                                                                ? c.replies
                                                                : c.replies.slice(0, 1)
                                                            ).map((r) => (
                                                                <div key={r.id_comment}
                                                                    ref={(el) =>
                                                                        commentRefs.current[
                                                                        r.id_comment
                                                                        ] = el
                                                                    }
                                                                    className={`
                                                                            reply-item
                                                                            ${Number(highlightedCommentId)
                                                                            === Number(r.id_comment)
                                                                            ? "highlighted-comment"
                                                                            : ""
                                                                        }
                                                                    `}
                                                                >

                                                                    <div className="reply-content">
                                                                        <b className="comment-username-link" onClick={() => navigate(`/user/${r.username}`)}>{r.username}</b>
                                                                        <span className="comment-date">
                                                                            {formatDate(r.created_at)}
                                                                        </span>
                                                                    </div>

                                                                    {editingCommentId === r.id_comment ? (

                                                                        <div className="edit-comment-box">
                                                                            <input
                                                                                type="text"
                                                                                value={editedCommentText}
                                                                                onChange={(e) => setEditedCommentText(e.target.value)}
                                                                            />

                                                                            <div className="edit-actions">
                                                                                <button onClick={() => setEditingCommentId(null)}>
                                                                                    {t("comments.cancel")}
                                                                                </button>

                                                                                <button onClick={() => handleSaveComment(r.id_comment)}>
                                                                                    {t("comments.save")}
                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                    ) : (

                                                                        <p>
                                                                            {r.comment.startsWith("@") ? (
                                                                                <span className="mention">
                                                                                    {r.comment.split(" ")[0]}
                                                                                </span>
                                                                            ) : null}

                                                                            {" "}
                                                                            {r.comment.replace(/^@\w+\s/, "")}
                                                                        </p>

                                                                    )}

                                                                    <div className="reply-actions-row">

                                                                        {/* DELETE */}
                                                                        {(parseInt(r.id_user) === parseInt(id_user) ||
                                                                            parseInt(post.id_user) === parseInt(id_user)) && (
                                                                                <button
                                                                                    onClick={() => confirmDeleteComment(r.id_comment)}
                                                                                >
                                                                                    {t("comments.delete")}
                                                                                </button>
                                                                            )}

                                                                        {/* EDIT */}
                                                                        {parseInt(r.id_user) === parseInt(id_user) && (
                                                                            <button onClick={() => handleEditComment(r)}>
                                                                                {t("comments.edit")}
                                                                            </button>
                                                                        )}

                                                                        {/* REPLY */}
                                                                        <button
                                                                            onClick={() => {
                                                                                setReplyingTo(r.id_comment);
                                                                                setReplyingUser(r.username);
                                                                            }}
                                                                        >
                                                                            {t("comments.reply")}
                                                                        </button>

                                                                    </div>

                                                                    {replyingTo === r.id_comment && (
                                                                        <div className="reply-box">
                                                                            <input
                                                                                type="text"
                                                                                placeholder={
                                                                                    t(
                                                                                        "comments.replyTo",
                                                                                        {
                                                                                            username:
                                                                                                replyingUser
                                                                                        }
                                                                                    )
                                                                                }
                                                                                value={replyText}
                                                                                onChange={(e) => setReplyText(e.target.value)}
                                                                            />

                                                                            <div className="reply-actions">
                                                                                <button onClick={() => setReplyingTo(null)}>
                                                                                    {t("comments.cancel")}
                                                                                </button>

                                                                                <button onClick={() => handleReply(r.id_comment)}>
                                                                                    {t("comments.reply")}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    )}


                                                                    <div className="comment-like-section">
                                                                        <button
                                                                            className={`like-comment ${Number(r.isLiked) === 1 ? "liked" : ""}`}
                                                                            onClick={() => handleLikeComment(r.id_comment)}
                                                                        >
                                                                            <FaHeart size={14} />
                                                                        </button>

                                                                        <span className="like-count">
                                                                            {r.likes || 0}
                                                                        </span>
                                                                    </div>


                                                                    {r.replies && r.replies.length > 0 && (
                                                                        <div>

                                                                            {r.replies && r.replies.length > 0 && (
                                                                                <div>
                                                                                    {r.replies.map(renderReplyItem)}
                                                                                </div>
                                                                            )}

                                                                        </div>
                                                                    )}

                                                                </div>
                                                            ))}


                                                            {c.replies.length > 1 && !expandedReplies[c.id_comment] && (
                                                                <span
                                                                    className="show-more-replies"
                                                                    onClick={() =>
                                                                        setExpandedReplies(prev => ({
                                                                            ...prev,
                                                                            [c.id_comment]: true
                                                                        }))
                                                                    }
                                                                >
                                                                    {
                                                                        c.replies.length - 1 > 1
                                                                            ? t(
                                                                                "comments.showMoreRepliesPlural",
                                                                                {
                                                                                    count:
                                                                                        c.replies.length - 1
                                                                                }
                                                                            )
                                                                            : t(
                                                                                "comments.showMoreReplies",
                                                                                {
                                                                                    count: 1
                                                                                }
                                                                            )
                                                                    }
                                                                </span>
                                                            )}

                                                            {expandedReplies[c.id_comment] && c.replies.length > 1 && (
                                                                <span
                                                                    className="hide-replies"
                                                                    onClick={() =>
                                                                        setExpandedReplies(prev => ({
                                                                            ...prev,
                                                                            [c.id_comment]: false
                                                                        }))
                                                                    }
                                                                >
                                                                    {t("comments.hideReplies")}
                                                                </span>
                                                            )}

                                                        </div>
                                                    )}
                                                </>

                                            )}



                                        </div>

                                        {/* RIGHT SIDE LIKE */}
                                        <div className="comment-like-section">

                                            <button
                                                className={`like-comment ${Number(c.isLiked) === 1 ? "liked" : ""}`}
                                                onClick={() => handleLikeComment(c.id_comment)}
                                            >
                                                <FaHeart size={14} />
                                            </button>

                                            <span className="like-count">
                                                {c.likes || 0}
                                            </span>

                                        </div>

                                    </div>
                                ))
                            )}

                        </div>

                        <div className="comment-input">
                            <input
                                type="text"
                                placeholder={
                                    t(
                                        "comments.writeComment"
                                    )
                                }
                                value={newComment}
                                onChange={(e) => setNewComment(e.target.value)}
                            />
                            <button onClick={handleAddComment}>
                                {t("comments.publish")}
                            </button>
                        </div>

                    </div>
                </div>
            )}
        </>
    )
}

export default PostComments
